import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Avatar from 'components/common/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NewCompany from 'components/modules/company/new/NewCompany';
import useAuth from 'hooks/useAuth';

const ProfileDropdown = ({ auth }) => {
 const { handleSubmit } = useAuth('logout');
 const [show, setShow] = useState(false);
 return (
  <>
   <Dropdown navbar={true} as="li">
    <Dropdown.Toggle bsPrefix="toggle" as="div" className="pe-0 ps-2 nav-link cursor-pointer">
     <OverlayTrigger
      key="left"
      placement="left"
      overlay={
       <Tooltip style={{ position: 'fixed' }} id="userName">
        {auth?.fullName}
       </Tooltip>
      }
     >
      <div className="theme-control-toggle-label">
       <Avatar src={auth?.avatar} name={auth?.fullName} />
      </div>
     </OverlayTrigger>
    </Dropdown.Toggle>

    <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
     <div className="bg-white rounded-2 py-2 dark__bg-1000">
      <Dropdown.Item className="fw-bold text-warning" onClick={() => setShow(true)}>
       <FontAwesomeIcon icon="crown" className="me-1" />
       <span>Crea Empresa</span>
      </Dropdown.Item>
      <Dropdown.Divider />
      {/* <Dropdown.Item href="#!">Set status</Dropdown.Item> */}
      <Dropdown.Item as={Link} to="/user/profile">
       Perfil
      </Dropdown.Item>
      {/* <Dropdown.Item href="#!">Feedback</Dropdown.Item> */}
      <Dropdown.Item as={Link} to="/user/settings">
       Configuracion
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item onClick={handleSubmit}>Cerrar sesion</Dropdown.Item>
     </div>
    </Dropdown.Menu>
   </Dropdown>
   <NewCompany show={show || false} setShow={setShow} />
  </>
 );
};

ProfileDropdown.propTypes = { auth: PropTypes.object };

export default ProfileDropdown;
